import {YMInitializer} from 'react-yandex-metrika';
import React from "react";
import usePixel from "./vk_pixel";

export const BookingMetrica = ({additionalMetrikaId = null}) => (
    <div className="metrika-main-div">
        <YMInitializer accounts={additionalMetrikaId ? [108802713, additionalMetrikaId] : [108802713]} options={
            {
                ssr: true,
                webvisor: true,
                clickmap: true,
                ecommerce: "dataLayer",
                referrer: document.referrer,
                url: window.location.href,
                accurateTrackBounce: true,
                trackLinks: true
            }
        }/>
        {usePixel('VK-RTRG-1051458-kT1O', 169)}
    </div>
);

